import { buildReducer } from '../../../../shared';
import {
    loadUserUnifiedGroupsCompletedAction,
    getGroupMembershipRequestsCompletedAction,
    fetchAllMembershipRequestsCompletedAction,
    unifiedGroupListRetryAction,
    fetchAllMembershipRequestsTimedOutAction,
    getGroupsSettingsCompletedAction,
} from '../../../../hub';
import { dismissCreateGroupDialogAction } from '../../../../editors/actions';
import type { GroupsHubPrefetchState } from '../../../state/data/groupsHubPrefetchState';

const defaultState: GroupsHubPrefetchState = {
    unifiedGroupListLoadingState: 'Loading',
    unifiedGroups: [],
    isGroupCreationEnabled: false,
    allowAddGuests: false,
    isSensitivityLabelsEnabled: false,
};

export default buildReducer<GroupsHubPrefetchState>()
    .handleDataAction(
        loadUserUnifiedGroupsCompletedAction,
        (state, action) => {
            return {
                ...state,
                unifiedGroups: action.payload.unifiedGroups,
            };
        },
        (state, action) => {
            return {
                ...state,
                unifiedGroupListLoadingState: 'Error',
            };
        }
    )
    .handle(dismissCreateGroupDialogAction, (state, action) => {
        const groupsList = [];
        if (action.payload.group) {
            groupsList.push(action.payload.group);
        }

        return {
            ...state,
            unifiedGroups: state.unifiedGroups
                ? state.unifiedGroups.concat(groupsList)
                : groupsList,
        };
    })
    .handleDataAction(getGroupMembershipRequestsCompletedAction, (state, action) => {
        return {
            ...state,
            unifiedGroups: state.unifiedGroups.map((group, index) =>
                group.externalDirectoryObjectId === action.payload.groupId
                    ? {
                          ...group,
                          pendingMembershipRequests: action.payload.membershipRequestsCount,
                      }
                    : group
            ),
        };
    })
    .handleDataAction(fetchAllMembershipRequestsCompletedAction, (state, action) => {
        return {
            ...state,
            unifiedGroupListLoadingState: 'Done',
        };
    })
    .handle(fetchAllMembershipRequestsTimedOutAction, (state, action) => {
        return {
            ...state,
            unifiedGroupListLoadingState: 'Done',
        };
    })
    .handle(unifiedGroupListRetryAction, (state, action) => {
        return {
            ...state,
            unifiedGroupListLoadingState: 'Loading',
        };
    })
    .handleDataAction(getGroupsSettingsCompletedAction, (state, action) => {
        return {
            ...state,
            isGroupCreationEnabled: action.payload.groupCreationEnabled,
            allowAddGuests: action.payload.allowAddGuests,
            isSensitivityLabelsEnabled: action.payload.isSensitivityLabelsEnabled,
        };
    })
    .done(defaultState);
export type { Action } from '../../../../shared';
